// extracted by mini-css-extract-plugin
export default {"event":"styles_event__g-M2z","textContainer":"styles_textContainer__PdXEw","text":"styles_text__677KP"};